module.exports = __webpack_public_path__ + "img/LUB00404.2249d1d6.png";